import { ref } from 'vue';

export interface ToastOptions {
  title: string;
  message: string;
  duration?: number;
  type?: 'success' | 'error' | 'info';
}

export function useToast() {
  const toast = ref<ToastOptions | null>(null);

  const showToast = (options: ToastOptions) => {
    const duration = options.duration || 5000;
    const type = options.type || 'info';

    toast.value = {
      title: options.title,
      message: options.message,
      duration,
      type
    };

    setTimeout(() => {
      toast.value = null;
    }, duration);
  };

  return {
    toast,
    showToast
  };
}
